<template>
  <div class="ac-toolbar">
    <button
      type="button"
      class="ac-tool"
      :class="{ 'is-on': focusOn }"
      :aria-pressed="focusOn ? 'true' : 'false'"
      data-test="ac-focus"
      @click="$emit('toggle-focus')"
    >
      <AcIcon :name="focusIcon" :size="13" />{{ focusLabel }}
    </button>
    <button type="button" class="ac-tool" data-test="ac-sort" @click="$emit('toggle-sort')">
      <AcIcon name="arrow-up-down" :size="13" />{{ sortOrder === 'old' ? 'Oldest first' : 'Newest first' }}
    </button>
    <span class="ac-toolbar-spacer"></span>
    <button
      v-if="canClear"
      type="button"
      class="ac-clear"
      data-test="ac-clear-all"
      @click="$emit('clear')"
    >
      <AcIcon name="check-check" :size="14" />{{ clearLabel }}
    </button>
  </div>
</template>

<script>
import AcIcon from './AcIcon.vue';

// Focus filter (one per chip), Newest/Oldest sort, and "Clear all" scoped to what's listed.
export default {
  name: 'ActionCenterToolbar',
  components: { AcIcon },
  props: {
    focusLabel: { type: String, required: true },
    focusIcon: { type: String, required: true },
    focusOn: { type: Boolean, default: false },
    sortOrder: { type: String, default: 'new' },
    clearLabel: { type: String, default: 'Clear all' },
    canClear: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.ac-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 14px 10px;
  border-bottom: 1px solid var(--ac-border);
}

.ac-tool {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 9px;
  border-radius: var(--ac-radius-md);
  border: 1px solid var(--ac-border);
  background: var(--ac-surface);
  color: var(--ac-neutral-600);
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    border-color: var(--ac-border-strong);
    color: var(--ac-text);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(91, 91, 214, 0.3);
  }

  &.is-on {
    background: var(--ac-iris-50);
    border-color: var(--ac-iris-200);
    color: var(--ac-iris-700);
  }
}

.ac-toolbar-spacer {
  flex: 1;
}

.ac-clear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  padding: 6px 0;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  color: var(--ac-iris-700);
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid var(--ac-iris-300);
    outline-offset: 2px;
    border-radius: 4px;
  }
}

@media (max-width: 767.98px) {
  .ac-tool {
    height: 44px;
    padding: 0 12px;
    font-size: 13px;
  }

  .ac-clear {
    min-height: 44px;
  }
}
</style>
